import React from 'react';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';

const StatsCard = ({ 
  title, 
  value, 
  subtitle, 
  icon: Icon, 
  color = 'primary',
  trend = null, // { value: 5.2, direction: 'up' }
  onClick = null
}) => {
  // Gradientes modernos como en el otro proyecto
  const gradients = {
    primary: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    success: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
    danger: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    warning: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
    info: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
    purple: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
  };

  const shadowColors = {
    primary: 'rgba(102, 126, 234, 0.3)',
    success: 'rgba(17, 153, 142, 0.3)',
    danger: 'rgba(240, 147, 251, 0.3)',
    warning: 'rgba(250, 112, 154, 0.3)',
    info: 'rgba(48, 207, 208, 0.3)',
    purple: 'rgba(102, 126, 234, 0.3)'
  };

  const [isHovered, setIsHovered] = React.useState(false);

  const cardStyle = {
    background: gradients[color] || gradients.primary,
    borderRadius: '12px',
    padding: '24px',
    color: 'white',
    boxShadow: isHovered 
      ? `0 12px 24px ${shadowColors[color] || shadowColors.primary}` 
      : `0 8px 16px ${shadowColors[color] || shadowColors.primary}`,
    transform: isHovered ? 'translateY(-4px)' : 'translateY(0)',
    transition: 'transform 0.2s, box-shadow 0.2s',
    cursor: onClick ? 'pointer' : 'default',
    height: '100%',
    border: 'none'
  };

  return (
    <div 
      style={cardStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
        <div style={{ flex: 1 }}>
          <div style={{ 
            fontSize: '13px', 
            opacity: 0.9, 
            fontWeight: 500,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            marginBottom: '8px'
          }}>
            {title}
          </div>
          <div style={{ 
            fontSize: '32px', 
            fontWeight: 'bold', 
            marginTop: '8px',
            lineHeight: '1'
          }}>
            {value}
          </div>
          {subtitle && (
            <div style={{ 
              fontSize: '13px', 
              opacity: 0.8, 
              marginTop: '8px'
            }}>
              {subtitle}
              {trend && (
                <span style={{ marginLeft: '8px', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                  {trend.direction === 'up' ? <FaArrowUp size={12} /> : <FaArrowDown size={12} />}
                  <span>{Math.abs(trend.value)}%</span>
                </span>
              )}
            </div>
          )}
        </div>
        <div style={{
          backgroundColor: 'rgba(255,255,255,0.2)',
          borderRadius: '50%',
          width: '48px',
          height: '48px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0
        }}>
          {Icon && <Icon size={24} />}
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
